import { StorageKey } from "@/enums";

export default class StoragService {

    get(key: StorageKey): any {
        let data = localStorage.getItem(key);
        let value: any = null;
        if (data) {
            try {
                value = JSON.parse(data);
            } catch (ex) {
                if (data)
                    value = data;
            }
        }
        return value;
    }

    set(key: StorageKey, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    remove(key:StorageKey){
        localStorage.removeItem(key);
    }

}